import React from 'react';
import './elements-svg.css';

const TechLines1 = (props) => {
  const { width, height } = props;
  
  return (
    <svg id="Layer_1" width={width} height={height} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 402 153.56">
      <path className="fill-grey"
            d="m234.38,153.56h-88.66l-.24-.42-44.09-76.36L145.72,0h88.66l.24.42,44.09,76.36-44.33,76.78Zm-87.7-1.66h86.74l43.37-75.11L233.42,1.66h-86.74l-43.37,75.11,43.37,75.11Z"/>
      <path className="fill-pink" d="m213.33,58.2h-86.61l-31-31H0v-1.66h96.41l31,31h85.92v1.66Z"/>
      <path className="fill-pink"
            d="m218.93,63.8c-3.55,0-6.43-2.89-6.43-6.43s2.89-6.43,6.43-6.43,6.43,2.89,6.43,6.43-2.89,6.43-6.43,6.43Zm0-11.2c-2.63,0-4.77,2.14-4.77,4.77s2.14,4.77,4.77,4.77,4.77-2.14,4.77-4.77-2.14-4.77-4.77-4.77Z"/>
      <path className="fill-pink" d="m325.31,20.19h-6.09l-12-13.04h6.08l12.01,13.04Z"/>
      <path className="fill-pink" d="m344.48,20.19h-6.08l-12.01-13.04h6.09l12,13.04Z"/>
      <path className="fill-pink" d="m363.66,20.19h-6.09l-12-13.04h6.08l12.01,13.04Z"/>
      <path className="fill-pink" d="m382.82,20.19h-6.08l-12.01-13.04h6.09l12,13.04Z"/>
      <path className="fill-pink" d="m402,20.19h-6.09l-12-13.04h6.08l12.01,13.04Z"/>
    </svg>
  );
}

export default TechLines1;